/* ===== Game Logic ===== */
import { $ } from '../utils/helpers.js?v=82.86';
import { showSnackbar } from '../utils/ui.js?v=82.86';
import { db } from '../config/firebase.js?v=82.86';
import { getCurrentSettings, loadSettings, setCurrentSettings } from './settings.js?v=82.86';
import { getCurrentUser } from './auth.js?v=82.86';
import { getPublicClientSlug } from './public-client.js?v=82.86';
import { updateTriesCounter } from '../ui/admin.js?v=82.86';
import { showPage } from '../ui/routing.js?v=82.86';
import { logger } from '../utils/logger.js?v=82.86';
import { updateGameStatsBackend } from './backend.js?v=82.86';
import { addPendingPlay, getPendingPlaysCount } from './pending-plays.js?v=82.86';
import { sanitizeImageSrc, sanitizeExternalHttpUrl } from '../utils/url.js?v=82.86';
import { normalizeTelHref } from '../utils/validation.js?v=82.86';
import {
  getContactLabel,
  getContactClientMessage,
  isContactModuleAvailable
} from '../ui/contact-module-client.js?v=82.86';
function restorePlayBtnLabel(btn, text) {
  if (!btn || !text) return;
  const labelEl = btn.querySelector('.client-premium-cta__label');
  if (labelEl) {
    labelEl.textContent = text;
  } else {
    btn.textContent = text;
  }
}

/** Premiu cu valoare („Voucher de 10 lei”, „10% reducere”) → imagine generată cu suma, nu un „LEI” generic. */
export function prizeValueArt(text) {
  const t = String(text || '');
  const pct = t.match(/(\d{1,3})\s*%/);
  const lei = t.match(/(\d{1,5})\s*(lei|ron)\b/i);
  let big = '';
  let small = '';
  let c1 = '#1D4ED8';
  let c2 = '#3B82F6';
  if (pct) { big = `${pct[1]}%`; small = 'REDUCERE'; c1 = '#0F6B3F'; c2 = '#22A065'; }
  else if (lei && /voucher|reducere|discount|card/i.test(t)) { big = `${lei[1]} LEI`; }
  if (!big) return '';
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 300"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="${c1}"/><stop offset="1" stop-color="${c2}"/></linearGradient></defs><rect width="600" height="300" fill="url(#g)"/><circle cx="70" cy="40" r="90" fill="#fff" opacity=".12"/><circle cx="540" cy="270" r="120" fill="#fff" opacity=".12"/><text x="300" y="${small ? 170 : 190}" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="130" font-weight="900" fill="#fff">${big}</text>${small ? `<text x="300" y="235" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="30" font-weight="800" letter-spacing="10" fill="#fff" opacity=".9">${small}</text>` : ''}</svg>`;
  try { return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`; } catch (_) { return ''; }
}

/** Tombola cu premii pe locuri: clientul doar se înscrie; premiile se trag la sorți la final. */
export function isDrawCampaign(s) {
  return !!s && s.campaignKind === 'tombola' && Array.isArray(s.drawPrizes) && s.drawPrizes.length > 0;
}

/** Afișul campaniei e o poză pusă de comerciant (nu una din iconițele standard /img/rewards/). */
function isCustomPoster(url) {
  const u = String(url || '').trim();
  return !!u && !/\/img\/rewards\//.test(u) && !u.startsWith('data:');
}

/** Sub afiș: Locul 1/2/3 cu premiile (din aceleași date ca regulamentul) — doar când afișul e o iconiță standard.
 *  Când comerciantul a pus un afiș propriu, premiile și data extragerii sunt deja pe el: sub afiș nu mai apare
 *  nimic, iar afișul e limitat ca înălțime, ca butonul „Înscrie-te” să fie vizibil fără scroll. */
function renderDrawPlaces(prize) {
  const s = getCurrentSettings() || {};
  let box = document.getElementById('sjDrawPlaces');
  const img = $('prizeImg');
  const inner = img ? img.closest('.popup-inner') : null;
  if (!isDrawCampaign(s)) {
    if (box) box.remove();
    if (inner) inner.classList.remove('sj-has-poster');
    return;
  }
  if (!img) return;
  const hasPoster = isCustomPoster(prize?.image);
  if (inner) inner.classList.toggle('sj-has-poster', hasPoster);
  if (hasPoster) {
    if (box) box.remove();
    return;
  }
  if (!box) {
    box = document.createElement('div');
    box.id = 'sjDrawPlaces';
    box.className = 'sj-drawplaces';
    img.after(box);
  }
  const esc = (x) => String(x ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const medal = ['🥇', '🥈', '🥉'];
  let n = 0;
  const rows = [];
  s.drawPrizes.forEach((p) => {
    const c = Math.max(1, parseInt(p.count, 10) || 1);
    for (let k = 0; k < c; k++) {
      n += 1;
      rows.push(`<li><span class="sj-drawplaces__m">${medal[n - 1] || '🎖️'}</span><b>Locul ${n}</b><span class="sj-drawplaces__p">${esc(p.message)}${Number(p.value) > 0 ? ` · ${esc(p.value)} lei` : ''}</span></li>`);
    }
  });
  box.innerHTML = `<ul>${rows.join('')}</ul>`;
}

function fillPrizePopupActions(actionsEl, { prize, pendingWin } = {}) {
  try { renderDrawPlaces(prize); } catch (_) { /* ignore */ }
  const root = actionsEl || $('popupActions');
  const primary = $('popupActionsPrimary') || root;
  if (!primary) return;

  while (primary.firstChild) {
    primary.removeChild(primary.firstChild);
  }
  if (root) root.classList.add('popup-actions--stacked');

  const rulesBtn = $('popupCampaignRulesBtn');
  if (rulesBtn) {
    rulesBtn.hidden = false;
    rulesBtn.style.display = 'flex';
  }
  // Documentele juridice complete: regulamentul și, separat, informarea GDPR
  import('../legal/legal-ui.js?v=82.86').then((lg) => {
    const cs = getCurrentSettings() || {};
    let g = $('popupCampaignGdprBtn');
    const on = !!lg.getDisplayDoc('gdpr', cs);
    if (!on) { if (g) g.hidden = true; return; }
    if (rulesBtn) rulesBtn.textContent = '📄 Regulament oficial';
    if (!g && rulesBtn) {
      g = document.createElement('button');
      g.type = 'button';
      g.id = 'popupCampaignGdprBtn';
      g.className = 'popup-rules-btn';
      g.textContent = '🔒 Informare GDPR completă';
      g.addEventListener('click', () => lg.openLegalDoc('gdpr', getCurrentSettings() || {}));
      rulesBtn.after(g);
    }
    if (g) { g.hidden = false; g.style.display = 'flex'; }
  }).catch(() => {});

  if (pendingWin) {
    const note = document.createElement('div');
    note.className = 'smallnote';
    note.textContent = 'Recompensa va fi confirmată la reconectare.';
    primary.appendChild(note);
  } else if (prize && !prize.isDefault) {
    if ($('playBtn')) $('playBtn').style.display = 'none';
    const b1 = document.createElement('button');
    b1.textContent = isDrawCampaign(getCurrentSettings()) ? '🎟️ Înscrie-te gratuit' : 'Revendică';
    b1.className = 'btn-claim-half';
    b1.onclick = window.startClaim;
    primary.appendChild(b1);
  }
}

// ✅ DEBUG: Flag pentru loguri de debugging (set to true pentru debugging, false pentru producție)
const DEBUG_PLAY = false;

let isPlaying = false;
let claimPrizeText = null;
const MENU_EMBED_TIMEOUT_MS = 3500;
let menuEmbedFallbackTimer = null;

// ✅ FIX: Funcție simplă pentru actualizare UI (fără over-engineering)
function setText(id, val) {
  const el = document.getElementById(id);
  if (!el) return;
  if (el.tagName === 'INPUT') el.value = String(val);
  else el.textContent = String(val);
}

// Funcție pentru sunet de câștig
function playWinSound() {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    
    // Generează un sunet de "victory" folosind oscilatoare
    // Nota 1: C (Do)
    const osc1 = audioContext.createOscillator();
    const gain1 = audioContext.createGain();
    osc1.connect(gain1);
    gain1.connect(audioContext.destination);
    
    osc1.frequency.value = 523.25; // C5
    osc1.type = 'sine';
    
    gain1.gain.setValueAtTime(0.3, audioContext.currentTime);
    gain1.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.15);
    
    osc1.start(audioContext.currentTime);
    osc1.stop(audioContext.currentTime + 0.15);
    
    // Nota 2: E (Mi) - după 100ms
    const osc2 = audioContext.createOscillator();
    const gain2 = audioContext.createGain();
    osc2.connect(gain2);
    gain2.connect(audioContext.destination);
    
    osc2.frequency.value = 659.25; // E5
    osc2.type = 'sine';
    
    gain2.gain.setValueAtTime(0.3, audioContext.currentTime + 0.1);
    gain2.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.25);
    
    osc2.start(audioContext.currentTime + 0.1);
    osc2.stop(audioContext.currentTime + 0.25);
    
    // Nota 3: G (Sol) - după 200ms
    const osc3 = audioContext.createOscillator();
    const gain3 = audioContext.createGain();
    osc3.connect(gain3);
    gain3.connect(audioContext.destination);
    
    osc3.frequency.value = 783.99; // G5
    osc3.type = 'sine';
    
    gain3.gain.setValueAtTime(0.4, audioContext.currentTime + 0.2);
    gain3.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.6);
    
    osc3.start(audioContext.currentTime + 0.2);
    osc3.stop(audioContext.currentTime + 0.6);
    
    // Nota finală: C (Do) octava superioară - după 400ms
    const osc4 = audioContext.createOscillator();
    const gain4 = audioContext.createGain();
    osc4.connect(gain4);
    gain4.connect(audioContext.destination);
    
    osc4.frequency.value = 1046.50; // C6
    osc4.type = 'sine';
    
    gain4.gain.setValueAtTime(0.5, audioContext.currentTime + 0.4);
    gain4.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.8);
    
    osc4.start(audioContext.currentTime + 0.4);
    osc4.stop(audioContext.currentTime + 0.8);
  } catch (e) {
    // Fallback: dacă Web Audio API nu este disponibil, nu afișăm eroare
    // Audio not available - silent fail
  }
}

function launchConfetti(currentSettings) {
  if ((currentSettings?.confetti || 'on') !== 'on') return;
  /* ✅ OPTIMIZATION: Reduce particle count for smaller screens */
  const N = Math.min(80, Math.floor(window.innerWidth / 10));
  const dur = 1200;

  for (let i = 0; i < N; i++) {
    const s = document.createElement('div');
    s.style.position = 'fixed';
    s.style.left = (Math.random() * 100) + 'vw';
    s.style.top = '-10px';
    s.style.width = '8px';
    s.style.height = '14px';
    s.style.background = 'hsl(' + Math.floor(Math.random() * 360) + ' 90% 55%)';
    s.style.opacity = '0.9';
    s.style.transform = 'rotate(' + Math.floor(Math.random() * 360) + 'deg)';
    s.style.zIndex = 2600;
    s.style.borderRadius = '2px';
    document.body.appendChild(s);

    const endY = (window.innerHeight * 0.9) + 'px';
    s.animate(
      [{ transform: s.style.transform + ' translateY(0)', opacity: 0.9 }, { transform: s.style.transform + ' translateY(' + endY + ')', opacity: 0.2 }],
      { duration: dur + Math.random() * 600, easing: 'cubic-bezier(.2,.8,.2,1)' }
    ).onfinish = () => s.remove();
  }
}

function pickWeightedPrize(prizes) {
  const total = prizes.reduce((s, p) => s + (parseInt(p.count) || 0), 0);
  if (total <= 0) return null;
  let r = Math.random() * total;
  for (let i = 0; i < prizes.length; i++) {
    const c = parseInt(prizes[i].count) || 0;
    if (c <= 0) continue;
    if ((r -= c) < 0) return i;
  }
  return null;
}

export async function playGame() {
  // Protecție anti-dublu-click
  if (isPlaying) return;
  isPlaying = true;

  const isOffline = !navigator.onLine;
  const publicSlug = getPublicClientSlug();
  const currentUser = getCurrentUser();

  if (!publicSlug && !currentUser) {
    isPlaying = false;
    return showSnackbar('Loghează-te!');
  }

  if (publicSlug && isOffline) {
    isPlaying = false;
    return showSnackbar('Ai nevoie de internet pentru a juca de pe telefon.');
  }

  let currentSettings = getCurrentSettings();
  
  // ✅ FIX 6: Hard guard at top - Firestore campaignStatus is SINGLE source of truth
  // UI must NEVER allow play when status !== 'active'
  const campaignStatus = currentSettings?.campaignStatus;
  if (campaignStatus !== 'active') {
    logger.warn('[playGame] Campaign not active:', campaignStatus);
    isPlaying = false;
    let statusMsg = 'Campania nu este activă.';
    if (campaignStatus === 'closed') {
      statusMsg = 'Campania este închisă.';
    } else if (campaignStatus === 'draft') {
      statusMsg = 'Campania nu este activă.';
    } else if (campaignStatus === 'archived') {
      statusMsg = 'Campania este arhivată.';
    }
    return showSnackbar(statusMsg);
  }
  
  // Răzuiește și câștigă: biletul vine de pe server, pe baza bonului
  if (currentSettings?.campaignKind === 'scratch' || (currentSettings?.campaignKind === 'guaranteed' && currentSettings?.receiptScan === true)) {
    isPlaying = false;
    const m = await import('../ui/scratch-card.js?v=82.86');
    m.openScratchFlow();
    return;
  }

  // ✅ DEBUG: Log la intrare (gated)
  if (DEBUG_PLAY) {
    logger.log('[PLAY] Entry - Online:', navigator.onLine, 'RemainingTries:', currentSettings?.remainingTries);
  }
  

  // Dezactivează butonul și înlocuiește textul cu spinner
  const btn = $('playBtn');
  let originalText = '';
  let playBtnLabelEl = null;
  if (btn) {
    playBtnLabelEl = btn.querySelector('.client-premium-cta__label');
    originalText =
      (playBtnLabelEl?.textContent || btn.textContent || btn.innerText || 'Apasă!').trim();
    btn.disabled = true;
    btn.style.pointerEvents = 'none';
    const spinner = document.createElement('span');
    spinner.className = 'inline-spinner';
    if (playBtnLabelEl) {
      playBtnLabelEl.textContent = '';
      playBtnLabelEl.appendChild(spinner);
    } else {
      btn.textContent = '';
      btn.appendChild(spinner);
    }
  }

  try {
    // ✅ FIX: Folosește setările locale (actualizate deja de saveAdminSettings)
    // Nu reîncărca dacă setările locale există - evită suprascrierea remainingTries
    let currentSettings = getCurrentSettings();
    
    // Doar dacă nu avem setări locale valide, reîncarcă
    if (!publicSlug && !currentSettings) {
      await loadSettings(currentUser.uid, false);
      currentSettings = getCurrentSettings();
    }

    // ✅ OPTIMISTIC UPDATES: Actualizează UI-ul imediat, trimite update-urile în background
    
    // 1. Calculează și actualizează local (optimistic)
    currentSettings.playsTotal = (currentSettings.playsTotal || 0) + 1;
    if ($('playsTotal')) $('playsTotal').textContent = String(currentSettings.playsTotal);
    // ✅ FIX: Persistă playsTotal în localStorage
    setCurrentSettings(currentSettings);

    // ✅ FIX: Guard sigur pentru NaN (folosește Number + isFinite în loc de parseInt)
    const totalTries = Number(currentSettings?.totalTries) || 0;
    let rem = Number(currentSettings?.remainingTries);
    if (!Number.isFinite(rem)) {
      rem = Number(currentSettings?.totalTries) || 0;
    }
    
    // ✅ FIX: Verifică și corectează remainingTries dacă e nevoie
    if (totalTries > 0) {
      // Dacă remainingTries > totalTries (imposibil), corectează-l
      if (rem > totalTries) {
        rem = totalTries;
        currentSettings.remainingTries = rem;
        setCurrentSettings(currentSettings);
      }
      
      // Acum verifică dacă mai ai încercări
      if (rem <= 0) {
        throw new Error('Nu mai ai încercări.');
      }
      
      // ✅ FIX CRITIC #1: NU decrementa local înainte de confirmarea din Firestore
      // NU salva optimistic remainingTries în localStorage - creează desync cross-device
      // Doar actualizează UI-ul optimistically pentru UX, dar listener-ul va actualiza valoarea reală
      
      const optimisticRem = Math.max(0, rem - 1);
      
      // ✅ DEBUG: Log după verificare (gated)
      if (DEBUG_PLAY) {
        logger.log('[PLAY] Before decrement - RemainingTries (Firestore):', rem, 'Optimistic UI:', optimisticRem, 'Online:', navigator.onLine);
      }
      
      // ✅ FIX: Actualizează DOAR UI-ul optimistically (DOM updates)
      // NU salva în localStorage - listener-ul va actualiza valoarea reală când Firestore se actualizează
      setText('modClientRemainingTries', totalTries > 0 ? optimisticRem : '—');
      
      // ✅ FIX: Update counter optimistically (va folosi valoarea reală din listener când se actualizează)
      // Temporarily update local state for UI only (NOT persisted)
      const tempSettings = { ...currentSettings, remainingTries: optimisticRem };
      // ❌ REMOVED: setCurrentSettings(tempSettings); // NU persista - creează desync!
      
      // ✅ FIX: Update counter cu valoarea optimistă (va fi suprascrisă de listener)
      updateTriesCounter();
      
      // ✅ FIX: Disable playBtn pentru 600ms pentru a preveni double-tap
      if (btn) {
        btn.disabled = true;
        btn.style.pointerEvents = 'none';
        setTimeout(() => {
          btn.disabled = false;
          btn.style.pointerEvents = '';
        }, 600);
      }
      
      // ✅ REMOVED: Nu mai salva remainingTries local separat - listener-ul va actualiza
    }

    const prizesArr = (currentSettings?.prizes || []).map(p => ({ ...p, count: parseInt(p.count) || 0 }));
    const winsLeft = prizesArr.reduce((s, p) => s + (p.count || 0), 0);

    const attemptsLeftNow = (totalTries > 0) ? rem : 1;
    let pWin = (totalTries > 0) ? (winsLeft / attemptsLeftNow) : (winsLeft > 0 ? 1 : 0);
    pWin = Math.max(0, Math.min(1, pWin));
    const willWin = (winsLeft > 0) && (Math.random() < pWin);

    let prize;
    let winningPrizeIndex = -1; // ✅ FIX: Track winning prize index
    
    if (isDrawCampaign(currentSettings)) {
      // Tombolă: toți participanții primesc același bilet de înscriere (cu afișul campaniei) — nu un premiu
      // tras la sorți dintre toate intrările listei. Dacă în listă au rămas și premii de la o campanie
      // veche (fără poză, text „Voucher 200 lei”…), unii vizitatori primeau aleatoriu pe acelea.
      const participationText = String(currentSettings?.campaignLegal?.participationText || '').trim();
      let idx = participationText ? prizesArr.findIndex((p) => (p.count || 0) > 0 && String(p.message || '').trim() === participationText) : -1;
      if (idx < 0) {
        // biletul e intrarea cu tirajul cel mai mare (se salvează cu 10000); premiile vechi au tiraje mici
        prizesArr.forEach((p, i) => {
          if ((p.count || 0) > 0 && String(p.message || '').trim() && (idx < 0 || (p.count || 0) > (prizesArr[idx].count || 0))) idx = i;
        });
      }
      if (idx >= 0) {
        prize = { ...prizesArr[idx], isDefault: false };
        winningPrizeIndex = idx;
        prizesArr[idx].count = Math.max(0, (prizesArr[idx].count || 0) - 1);
        currentSettings.prizes = prizesArr;
        setCurrentSettings(currentSettings);
        launchConfetti(currentSettings);
        playWinSound();
      }
    } else if (willWin) {
      const idx = pickWeightedPrize(prizesArr);
      if (idx != null && idx >= 0) {
        prize = { ...prizesArr[idx], isDefault: false };
        winningPrizeIndex = idx; // ✅ FIX: Save the index for later use
        prizesArr[idx].count = Math.max(0, (prizesArr[idx].count || 0) - 1);
        currentSettings.prizes = prizesArr;
        // ✅ FIX: Persistă prizes în localStorage
        setCurrentSettings(currentSettings);
        
        launchConfetti(currentSettings);
        playWinSound(); // Sunet de câștig
      }
    }
    
    if (!prize) {
      prize = {
        message: currentSettings?.defaultPrizeMsg || 'Ne pare rău, nu ai câștigat!',
        image: currentSettings?.defaultPrizeImg || null,
        isDefault: true
      };
    }

    // 2. Salvează toate actualizările locale
    setCurrentSettings(currentSettings);

    // ✅ OPTIMIZATION: Afișează premiul IMEDIAT (optimistic UI)
    // Ascunde spinner-ul și restabilește textul butonului
    if (btn && originalText) {
      restorePlayBtnLabel(btn, originalText);
    }

    const pendingWin = isOffline && !prize.isDefault;
    const msg = pendingWin
      ? 'Recompensă în verificare (așteaptă confirmarea)'
      : (prize.message && prize.message.trim())
        || (prize.isDefault ? 'Ne pare rău, nu ai câștigat!' : 'Ai câștigat o recompensă!');

    claimPrizeText = msg;
    sessionStorage.setItem('sj_lastPrize', msg);

    if ($('prizeText')) $('prizeText').textContent = msg;

    const imgEl = $('prizeImg');
    // Imaginea generată „200 LEI” doar când comerciantul n-a pus nicio poză și nu e tombolă: afișul pus de el
    // are prioritate (înainte, un text ca „Voucher 200 lei” în bilet înlocuia afișul cu arta generată).
    const valueArt = !pendingWin && !prize.isDefault && !prize.image && !isDrawCampaign(currentSettings) ? prizeValueArt(msg) : '';
    if (imgEl && valueArt) {
      imgEl.style.display = 'block';
      imgEl.src = valueArt;
      imgEl.classList.add('img-loaded');
    } else if (imgEl) {
      if (prize.image && !pendingWin) {
        const safeUrl = sanitizeImageSrc(prize.image);
        if (safeUrl) {
          imgEl.style.display = 'block';
          imgEl.classList.remove('img-loaded');
          const probe = new Image();
          probe.onload = () => { imgEl.src = safeUrl; imgEl.classList.add('img-loaded'); };
          probe.onerror = () => { imgEl.style.display = 'none'; imgEl.removeAttribute('src'); };
          probe.src = safeUrl;
        } else {
          imgEl.style.display = 'none';
          imgEl.removeAttribute('src');
        }
      } else {
        imgEl.style.display = 'none';
        imgEl.removeAttribute('src');
      }
    }

    fillPrizePopupActions($('popupActions'), { prize, pendingWin });
    
    // ✅ OPTIMIZATION: Afișează popup-ul IMEDIAT
    const popup = $('popup');
    if (popup) popup.classList.add('active');

    // Reactivează butonul
    if (btn) {
      btn.disabled = false;
      btn.style.pointerEvents = '';
    }

    // ✅ FIX P0: Generate playId for idempotency
    const playId = `play_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    
    // ✅ FIX P0: Event-based update (delta only, not array)
    const eventUpdate = {
      playId: playId,
      decrementRemainingTries: totalTries > 0, // Decrementează doar dacă totalTries > 0
      prizeId: null // Will be set if prize won
    };
    
    // ✅ FIX: Use the saved winning prize index directly instead of searching again
    if (prize && !prize.isDefault && winningPrizeIndex !== -1) {
      eventUpdate.prizeId = `prize_${winningPrizeIndex}`;
    }

    // ✅ FIX P0 + P1: Validează în background (NU mai blochează UI-ul)
    // Popup-ul este deja afișat, validarea se face în paralel
    if (!pendingWin) {
      sessionStorage.removeItem('sj_pending_play_id');
      sessionStorage.removeItem('sj_pending_prize_msg');
      sessionStorage.removeItem('sj_pending_prize_img');
    }

    if (navigator.onLine) {
      updateGameStatsBackend(eventUpdate, { publicSlug: publicSlug || null })
        .then(result => {
          if (!result || result.success !== true) {
            if (eventUpdate.prizeId) {
              // Dacă premiul nu a fost validat, logăm dar nu blocăm UI-ul
              logger.warn('[playGame] Prize validation failed');
            }
          } else if (eventUpdate.prizeId && !publicSlug) {
            // ✅ Refresh settings to show updated prize stock immediately
            loadSettings(currentUser.uid, true).then(() => {
              if (window.updateSectionSummaries) {
                window.updateSectionSummaries();
              }
            });
          }
          
          // ✅ DACĂ premiul nu e disponibil (race condition), schimbă la default
          if (result && !result.success && eventUpdate.prizeId) downgradeToDefaultPrize('result.success=false');
        })
        .catch(e => {
          // Serverul a REFUZAT jocul (nu mai sunt încercări / premiul s-a terminat / campania nu e activă):
          // nu lăsăm popup-ul „Ai câștigat” + „Revendică” pe ecran, altfel se dau mai multe premii decât există.
          // Doar erorile de rețea rămân „non-blocking” (jocul e pus în coadă și se trimite la reconectare).
          const code = String(e?.code || '').replace(/^functions\//, '');
          const serverRejected = ['resource-exhausted', 'not-found', 'failed-precondition', 'permission-denied', 'invalid-argument'].includes(code);
          if (serverRejected && eventUpdate.prizeId) {
            logger.warn('[playGame] CF rejected the play:', code, e?.message, '- switching to default prize');
            // mesajele serverului sunt pentru client („Campania nu este activă”, „Nu mai sunt încercări disponibile”);
            // cel cu ID-ul premiului nu
            const friendly = String(e?.message || '');
            downgradeToDefaultPrize(code, /prize_|nu există/i.test(friendly) ? '' : friendly);
          } else {
            logger.warn('[playGame] CF validation error (non-blocking):', e?.message);
          }
        });

      function downgradeToDefaultPrize(reason, message = '') {
            logger.warn('[playGame] Prize not available (' + reason + ') - switching to default prize');
            // Actualizează popup-ul cu mesajul default
            const prizeTextEl = $('prizeText');
            const prizeImgEl = $('prizeImg');
            const actionsEl = $('popupActions');
            
            if (prizeTextEl) {
              prizeTextEl.textContent = message || currentSettings?.defaultPrizeMsg || 'Ne pare rău, nu ai câștigat!';
            }
            if (prizeImgEl) {
              if (currentSettings?.defaultPrizeImg) {
                const safeUrl = sanitizeImageSrc(currentSettings.defaultPrizeImg);
                if (safeUrl) {
                  prizeImgEl.style.display = 'block';
                  prizeImgEl.classList.remove('img-loaded');
                  const p = new Image();
                  p.onload = () => { prizeImgEl.src = safeUrl; prizeImgEl.classList.add('img-loaded'); };
                  p.onerror = () => { prizeImgEl.style.display = 'none'; prizeImgEl.removeAttribute('src'); };
                  p.src = safeUrl;
                } else {
                  prizeImgEl.style.display = 'none';
                  prizeImgEl.removeAttribute('src');
                }
              } else {
                prizeImgEl.style.display = 'none';
                prizeImgEl.removeAttribute('src');
              }
            }
            fillPrizePopupActions(actionsEl, {
              prize: { isDefault: true },
              pendingWin: false
            });
            if ($('playBtn')) $('playBtn').style.display = '';
            
            // Actualizează și claimPrizeText
            claimPrizeText = currentSettings?.defaultPrizeMsg || 'Ne pare rău, nu ai câștigat!';
            sessionStorage.setItem('sj_lastPrize', claimPrizeText);
      }
    } else if (!publicSlug) {
      // ✅ FIX P1: Offline - salvează atomic în IndexedDB (multi-tab safe)
      addPendingPlay(playId, currentUser.uid, {
        decrementRemainingTries: eventUpdate.decrementRemainingTries,
        prizeId: eventUpdate.prizeId,
        pendingStatus: pendingWin ? 'pending' : 'none',
        pendingPrizeMessage: pendingWin ? prize.message : null,
        pendingPrizeImage: pendingWin ? prize.image : null
      }).then(() => {
        logger.info('[playGame] Pending play saved atomically (offline):', playId);
      }).catch(e => {
        logger.error('[playGame] Failed to save pending play:', e);
      });
      
      if (pendingWin) {
        sessionStorage.setItem('sj_pending_play_id', playId);
        sessionStorage.setItem('sj_pending_prize_msg', prize.message || '');
        sessionStorage.setItem('sj_pending_prize_img', prize.image || '');
      }

      // Trimite în background prin queue (fallback)
      updateGameStatsBackend(eventUpdate).catch(e => {
        logger.error('[playGame] Background update failed (non-critical):', e);
      });
    }

  } catch (e) {
    // La eroare: ascunde spinner, reactivează buton, restabilește textul și afișează mesaj
    if (btn) {
      if (originalText) {
        restorePlayBtnLabel(btn, originalText);
      }
      btn.disabled = false;
      btn.style.pointerEvents = '';
    }

    const errorMsg = e?.message || 'Se încarcă prea mult, încearcă din nou';
    showSnackbar(errorMsg);
    logger.error('[playGame] Error:', e);
  } finally {
    // ✅ FIX: Garantează resetarea flag-ului isPlaying în toate cazurile
    isPlaying = false;
  }
}

export function closePopup() {
  const popup = $('popup');
  if (popup) popup.classList.remove('active');
  
  const prizeText = $('prizeText');
  if (prizeText) prizeText.textContent = '';
  
  const img = $('prizeImg');
  if (img) {
    img.removeAttribute('src');
    img.style.display = 'none';
  }
  
  const clientPage = document.getElementById('clientPage');
  if (clientPage && clientPage.classList.contains('visible')) {
    import('../ui/slideshow.js?v=82.86')
      .then((m) => m.applyClientUI())
      .catch(() => {});
  }
}

export async function startClaim() {
  // Demo neactivat: clienții nu lasă date personale (nu există încă operator de date). Serverul refuză oricum.
  if (getCurrentSettings()?.internalDemo === true) {
    showSnackbar('Pagină demonstrativă: aici clientul își lasă numele și telefonul. Înscrierile pornesc odată cu activarea contului.', 'info');
    return;
  }
  closePopup();
  await showPage('claimPage');
  
  // premiul în antetul formularului
  const prizeLine = $('claimPrizeLine');
  if (prizeLine) prizeLine.textContent = getClaimPrizeText() || '';
  if ($('claimName')) $('claimName').value = '';
  if ($('claimContact')) $('claimContact').value = '';
  if ($('claimGDPR')) $('claimGDPR').checked = false;
  if ($('claimMKT')) $('claimMKT').checked = false;
  
  // Resetează butonul "Trimite" la starea inițială
  const submitBtn = $('submitClaimBtn');
  if (submitBtn) {
    submitBtn.disabled = false;
    submitBtn.style.pointerEvents = '';
    submitBtn.classList.remove('btn-disabled-state');
    submitBtn.textContent = '🎁 Primește voucherul';
  }
  
  // Resetează flag-ul isSubmittingClaim din claims.js
  try {
    const { resetClaimFormState } = await import('./claims.js?v=82.86');
    if (resetClaimFormState) resetClaimFormState();
  } catch (e) {
    // Ignoră eroarea dacă funcția nu există încă
  }
}

export function getClaimPrizeText() {
  return claimPrizeText || sessionStorage.getItem('sj_lastPrize') || 'Recompensă';
}

export function clearClaimPrizeText() {
  claimPrizeText = null;
  sessionStorage.removeItem('sj_lastPrize');
}

function getMenuModeElements() {
  return {
    clientPage: document.getElementById('clientPage'),
    modeRoot: document.getElementById('clientMenuMode'),
    brandBtn: document.getElementById('clientMenuBrandBtn'),
    campaignBtn: document.getElementById('clientMenuCampaignBtn'),
    iframe: document.getElementById('clientMenuIframe'),
    fallback: document.getElementById('clientMenuFallback'),
    fallbackText: document.getElementById('clientMenuFallbackText')
  };
}

function getLocationBrandName(settings) {
  const raw = String(settings?.companyName || '').trim();
  if (!raw) return 'SpressJoy';
  const cleaned = raw
    .replace(/\bSC\b\.?/gi, '')
    .replace(/\bS\.C\.\b/gi, '')
    .replace(/\bSRL\b\.?/gi, '')
    .replace(/\bS\.R\.L\.\b/gi, '')
    .replace(/\bSA\b\.?/gi, '')
    .replace(/\bS\.A\.\b/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
  return cleaned || raw || 'SpressJoy';
}

function clearMenuEmbedTimer() {
  if (menuEmbedFallbackTimer) {
    clearTimeout(menuEmbedFallbackTimer);
    menuEmbedFallbackTimer = null;
  }
}

function setMenuFallbackVisible(visible, message = '') {
  const { fallback, fallbackText } = getMenuModeElements();
  if (!fallback) return;
  if (fallbackText && message) {
    fallbackText.textContent = message;
  }
  fallback.hidden = !visible;
}

export function closeLocationMenuMode() {
  clearMenuEmbedTimer();
  const { clientPage, modeRoot, iframe, fallback } = getMenuModeElements();
  if (!modeRoot) return;
  if (clientPage) {
    clientPage.classList.remove('client-menu-mode-active');
  }
  modeRoot.hidden = true;
  modeRoot.setAttribute('aria-hidden', 'true');
  if (fallback) fallback.hidden = true;
  if (iframe) iframe.removeAttribute('src');
}

function enterLocationMenuMode(url, settings) {
  const { clientPage, modeRoot, brandBtn, campaignBtn, iframe } = getMenuModeElements();
  if (!modeRoot || !iframe) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }
  clearMenuEmbedTimer();
  setMenuFallbackVisible(false);

  if (brandBtn) {
    brandBtn.textContent = getLocationBrandName(settings);
  }
  if (campaignBtn) {
    const playBtn = document.getElementById('playBtn');
    const campaignText = String(playBtn?.textContent || '').trim() || 'Campanie';
    campaignBtn.textContent = campaignText;
    campaignBtn.setAttribute('aria-label', campaignText);
  }

  if (clientPage) {
    clientPage.classList.add('client-menu-mode-active');
  }
  modeRoot.hidden = false;
  modeRoot.setAttribute('aria-hidden', 'false');
  iframe.src = url;

  // If embed is blocked by X-Frame-Options / CSP, load may not succeed in a useful way.
  menuEmbedFallbackTimer = setTimeout(() => {
    setMenuFallbackVisible(
      true,
      'Meniul extern pare blocat în aplicație. Poți continua din butonul de mai jos.'
    );
  }, MENU_EMBED_TIMEOUT_MS);

  iframe.addEventListener('load', clearMenuEmbedTimer, { once: true });
}

export function openLocationMapPopup() {
  const currentSettings = getCurrentSettings();
  const mapsUrl = sanitizeExternalHttpUrl(currentSettings?.locationMapUrl || '');
  if (currentSettings?.locationMapEnabled !== true || !mapsUrl) {
    showSnackbar('Locație indisponibilă');
    return;
  }

  const popup = document.getElementById('locationMapPopup');
  const nameEl = document.getElementById('locationMapPopupName');
  const addressEl = document.getElementById('locationMapPopupAddress');
  const openBtn = document.getElementById('locationMapPopupOpenBtn');
  if (!popup || !nameEl || !addressEl || !openBtn) return;

  const name = String(currentSettings?.locationMapName || '').trim();
  const address = String(currentSettings?.locationMapAddress || '').trim();

  if (name) {
    nameEl.textContent = name;
    nameEl.style.display = '';
  } else {
    nameEl.textContent = '';
    nameEl.style.display = 'none';
  }

  if (address) {
    addressEl.textContent = address;
    addressEl.style.display = '';
  } else {
    addressEl.textContent = '';
    addressEl.style.display = 'none';
  }

  openBtn.href = mapsUrl;
  setupLocationMapExtras({ name, address, mapsUrl });
  popup.classList.add('active');
}

/** Interogarea pentru harta din fereastră: nume + adresă; altfel coordonatele/căutarea din linkul Maps. */
function locationEmbedQuery(name, address, mapsUrl) {
  const text = [name, address].filter(Boolean).join(', ');
  if (address) return text;
  try {
    const u = new URL(mapsUrl);
    const at = u.pathname.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
    if (at) return `${at[1]},${at[2]}`;
    const q = u.searchParams.get('q') || u.searchParams.get('query') || u.searchParams.get('destination');
    if (q) return q;
    const place = u.pathname.match(/\/place\/([^/]+)/);
    if (place) return decodeURIComponent(place[1].replace(/\+/g, ' '));
  } catch (_) { /* link scurt (maps.app.goo.gl) — nu se poate citi */ }
  return text;
}

/** Harta (se încarcă doar la apăsare: fără cookie-uri Google până atunci) + „Trimite locația”. */
function setupLocationMapExtras({ name, address, mapsUrl }) {
  const wrap = document.getElementById('locationMapPopupEmbed');
  const loadBtn = document.getElementById('locationMapPopupEmbedBtn');
  const shareBtn = document.getElementById('locationMapPopupShareBtn');
  const query = locationEmbedQuery(name, address, mapsUrl);
  if (wrap && loadBtn) {
    wrap.querySelector('iframe')?.remove();
    loadBtn.hidden = false;
    wrap.hidden = !query;
    loadBtn.onclick = () => {
      const f = document.createElement('iframe');
      f.className = 'location-map-embed__frame';
      f.title = name ? `Hartă ${name}` : 'Hartă locație';
      f.loading = 'lazy';
      f.referrerPolicy = 'no-referrer-when-downgrade';
      f.src = `https://www.google.com/maps?q=${encodeURIComponent(query)}&hl=ro&z=16&output=embed`;
      loadBtn.hidden = true;
      wrap.appendChild(f);
    };
  }
  if (shareBtn) {
    shareBtn.onclick = async () => {
      const text = [name, address].filter(Boolean).join('\n');
      if (navigator.share) {
        try {
          await navigator.share({ title: name || 'Locație', text, url: mapsUrl });
          return;
        } catch (e) {
          if (e && e.name === 'AbortError') return;
        }
      }
      const msg = [text, mapsUrl].filter(Boolean).join('\n');
      window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank', 'noopener');
    };
  }
}

export function closeLocationMapPopup() {
  const popup = document.getElementById('locationMapPopup');
  const openBtn = document.getElementById('locationMapPopupOpenBtn');
  if (popup) popup.classList.remove('active');
  if (openBtn) openBtn.href = '#';
  document.querySelector('#locationMapPopupEmbed iframe')?.remove();
}

export function openReservationPopup() {
  const currentSettings = getCurrentSettings();
  if (!isContactModuleAvailable(currentSettings)) {
    showSnackbar(`${getContactLabel(currentSettings)} indisponibil`);
    return;
  }
  const phone = String(currentSettings?.reservationPhone || '').trim();
  const telHref = phone ? normalizeTelHref(phone) : '';
  const waHref = whatsappHref(currentSettings?.reservationWhatsapp);
  const link = String(currentSettings?.reservationLink || '').trim();
  const linkHref = /^https?:\/\//i.test(link) ? link : '';
  if (!telHref && !waHref && !linkHref) {
    showSnackbar('Număr de telefon invalid');
    return;
  }

  const popup = document.getElementById('reservationPopup');
  const titleEl = document.getElementById('reservationPopupTitle');
  const msgEl = document.getElementById('reservationPopupMessage');
  const callBtn = document.getElementById('reservationPopupCallBtn');
  if (!popup || !titleEl || !msgEl || !callBtn) return;

  const label = getContactLabel(currentSettings);
  titleEl.textContent = label;

  const message = getContactClientMessage(currentSettings);
  if (message) {
    msgEl.textContent = message;
    msgEl.hidden = false;
  } else {
    msgEl.textContent = '';
    msgEl.hidden = true;
  }

  // un buton pentru fiecare variantă completată: telefon, WhatsApp, link
  callBtn.hidden = !telHref;
  callBtn.style.display = telHref ? '' : 'none';
  if (telHref) {
    callBtn.href = telHref;
    callBtn.textContent = 'Sună acum';
    callBtn.setAttribute('aria-label', `Sună ${phone}`);
  }
  const waBtn = document.getElementById('reservationPopupWhatsappBtn');
  if (waBtn) {
    waBtn.hidden = !waHref;
    waBtn.style.display = waHref ? '' : 'none';
    if (waHref) { waBtn.href = waHref; waBtn.textContent = 'Scrie pe WhatsApp'; }
  }
  const linkBtn = document.getElementById('reservationPopupLinkBtn');
  if (linkBtn) {
    linkBtn.hidden = !linkHref;
    linkBtn.style.display = linkHref ? '' : 'none';
    if (linkHref) {
      linkBtn.href = linkHref;
      linkBtn.textContent = String(currentSettings?.reservationLinkLabel || '').trim() || 'Comandă online';
    }
  }
  popup.classList.add('active');
}

/** wa.me cere numărul în format internațional, fără + și fără 0 în față (07… → 407…). */
function whatsappHref(raw) {
  let d = String(raw || '').replace(/\D/g, '');
  if (!d) return '';
  if (d.startsWith('00')) d = d.slice(2);
  else if (/^0\d{9}$/.test(d)) d = `4${d}`;
  else if (/^7\d{8}$/.test(d)) d = `40${d}`;
  if (d.length < 8 || d.length > 15) return '';
  return `https://wa.me/${d}`;
}

export function closeReservationPopup() {
  const popup = document.getElementById('reservationPopup');
  if (popup) popup.classList.remove('active');
}

export function openLocationHoursPopup() {
  const currentSettings = getCurrentSettings();
  const url = sanitizeImageSrc(currentSettings?.locationHoursImageURL || '');
  if (!url || currentSettings?.locationHoursEnabled !== true) {
    showSnackbar('Program locație indisponibil');
    return;
  }
  const popup = document.getElementById('locationHoursPopup');
  const img = document.getElementById('locationHoursPopupImg');
  if (!popup || !img) return;
  img.src = url;
  img.style.display = '';
  popup.classList.add('active');
}

export function closeLocationHoursPopup() {
  const popup = document.getElementById('locationHoursPopup');
  const img = document.getElementById('locationHoursPopupImg');
  if (popup) popup.classList.remove('active');
  if (img) {
    img.removeAttribute('src');
    img.style.display = 'none';
  }
}

export function openLocationMenuExternal() {
  const currentSettings = getCurrentSettings();
  const url = sanitizeExternalHttpUrl(currentSettings?.menuUrl || '');
  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }
  import('../ui/menu-module-client.js?v=82.86')
    .then((m) => {
      if (m.getMenuImages(currentSettings).length > 0) {
        m.openMenuGalleryOverlay(currentSettings);
      } else {
        showSnackbar('Meniu indisponibil');
      }
    })
    .catch(() => showSnackbar('Meniu indisponibil'));
}

export function openClientCampaignFromMenuMode() {
  closeLocationMenuMode();
  setTimeout(() => {
    playGame().catch(() => {});
  }, 80);
}

// Make available globally for onclick handlers
window.playGame = playGame;
window.closePopup = closePopup;
window.startClaim = startClaim;

// Pending win reconciliation handler (called after offline sync)
window.handlePendingWinReconciliation = function({ playId, status, message }) {
  const pendingId = sessionStorage.getItem('sj_pending_play_id');
  if (!pendingId || pendingId !== playId) return false;
  
  const pendingMsg = sessionStorage.getItem('sj_pending_prize_msg') || 'Recompensă';
  const pendingImg = sessionStorage.getItem('sj_pending_prize_img') || '';
  const popup = $('popup');
  
  if (status === 'confirmed') {
    const confirmedText = `Recompensă confirmată: ${pendingMsg}`;
    claimPrizeText = pendingMsg;
    sessionStorage.setItem('sj_lastPrize', pendingMsg);
    if ($('prizeText')) $('prizeText').textContent = confirmedText;
    
    const imgEl = $('prizeImg');
    if (imgEl) {
      const safeUrl = sanitizeImageSrc(pendingImg);
      if (safeUrl) {
        imgEl.style.display = 'block';
        imgEl.classList.remove('img-loaded');
        const p = new Image();
        p.onload = () => { imgEl.src = safeUrl; imgEl.classList.add('img-loaded'); };
        p.onerror = () => { imgEl.style.display = 'none'; imgEl.removeAttribute('src'); };
        p.src = safeUrl;
      } else {
        imgEl.style.display = 'none';
        imgEl.removeAttribute('src');
      }
    }
    
    fillPrizePopupActions($('popupActions'), {
      prize: { isDefault: false },
      pendingWin: false
    });

    if (popup) popup.classList.add('active');
    showSnackbar('Recompensa a fost confirmată.', 'success');
  } else if (status === 'rejected') {
    const currentSettings = getCurrentSettings();
    const rejectedText = 'Recompensă nevalidată. Nu a putut fi confirmată.';
    claimPrizeText = currentSettings?.defaultPrizeMsg || 'Ne pare rău, nu ai câștigat!';
    sessionStorage.setItem('sj_lastPrize', claimPrizeText);
    if ($('prizeText')) $('prizeText').textContent = rejectedText;
    const imgEl = $('prizeImg');
    if (imgEl) {
      imgEl.style.display = 'none';
      imgEl.removeAttribute('src');
    }
    fillPrizePopupActions($('popupActions'), {
      prize: { isDefault: true },
      pendingWin: false
    });
    if ($('playBtn')) $('playBtn').style.display = '';
    if (popup) popup.classList.add('active');
    showSnackbar(message || 'Recompensa nu a putut fi validată. Stoc epuizat sau conflict.', 'error');
  }
  
  sessionStorage.removeItem('sj_pending_play_id');
  sessionStorage.removeItem('sj_pending_prize_msg');
  sessionStorage.removeItem('sj_pending_prize_img');
  return true;
};

/** Deschide meniul: link direct (slug), QR auto (tabletă) sau galerie imagini */
export function openLocationMenu() {
  const currentSettings = getCurrentSettings();
  const enabled = currentSettings?.menuEnabled !== false;
  const url = sanitizeExternalHttpUrl(currentSettings?.menuUrl || '');
  const images = (() => {
    if (!Array.isArray(currentSettings?.menuImages)) return [];
    return currentSettings.menuImages.map((u) => String(u || '').trim()).filter(Boolean);
  })();

  if (!enabled || (!url && images.length === 0)) {
    showSnackbar('Meniu indisponibil');
    return;
  }

  const publicSlug = getPublicClientSlug();
  const kiosk = isKioskTabletMode();
  const menuLabel = String(currentSettings?.menuLabel || '').trim() || 'Meniu';

  if (publicSlug && url) {
    // meniul se deschide în tab nou; pagina locației rămâne deschisă
    const w = window.open(url, '_blank');
    if (w) {
      try { w.opener = null; } catch (_) { /* ignore */ }
    } else {
      window.location.assign(url);
    }
    return;
  }

  if (kiosk && url) {
    openExternalActionQrPopup('website', url, {
      title: `Scanează pentru ${menuLabel}`,
      subtext: 'Scanează cu telefonul pentru a deschide meniul.',
      imageUrl: null
    });
    return;
  }

  if (images.length > 0) {
    import('../ui/menu-module-client.js?v=82.86')
      .then((m) => m.openMenuGalleryOverlay(currentSettings))
      .catch(() => showSnackbar('Nu am putut deschide galeria.', 'error'));
    return;
  }

  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }

  showSnackbar('Meniu indisponibil');
}

function isKioskTabletMode() {
  // Public slug (/m/{slug}) is primarily phone/web flow => direct links.
  if (getPublicClientSlug()) return false;
  if (typeof window === 'undefined') return false;

  // Optional override for controlled environments.
  if (window.__SJ_FORCE_KIOSK__ === true) return true;
  if (window.__SJ_FORCE_KIOSK__ === false) return false;

  const standalone =
    window.matchMedia?.('(display-mode: standalone)')?.matches ||
    window.matchMedia?.('(display-mode: fullscreen)')?.matches;
  const coarse = window.matchMedia?.('(pointer: coarse)')?.matches;
  const tabletLikeViewport = Math.max(window.innerWidth || 0, window.innerHeight || 0) >= 900;
  return Boolean(standalone || (coarse && tabletLikeViewport));
}

function getExternalActionUrl(actionType, settings) {
  const s = settings || {};
  const type = String(actionType || '').toLowerCase();
  switch (type) {
    case 'review':
    case 'recenzie':
      return sanitizeExternalHttpUrl(s.clientFeedbackUrl || '');
    case 'facebook':
      return sanitizeExternalHttpUrl(s.socialMedia?.facebook?.link || s.clientSocialUrl || '');
    case 'instagram':
      return sanitizeExternalHttpUrl(s.socialMedia?.instagram?.link || s.clientInstagramUrl || '');
    case 'tiktok':
      return sanitizeExternalHttpUrl(s.socialMedia?.tiktok?.link || '');
    case 'website':
      return sanitizeExternalHttpUrl(s.clientWebsiteUrl || s.menuUrl || '');
    case 'social':
    case 'social-media':
      return (
        sanitizeExternalHttpUrl(s.socialMedia?.facebook?.link || s.clientSocialUrl || '') ||
        sanitizeExternalHttpUrl(s.socialMedia?.instagram?.link || s.clientInstagramUrl || '') ||
        sanitizeExternalHttpUrl(s.socialMedia?.tiktok?.link || '') ||
        sanitizeExternalHttpUrl(s.clientWebsiteUrl || s.menuUrl || '')
      );
    default:
      return null;
  }
}

function getExternalActionTitle(actionType) {
  switch (String(actionType || '').toLowerCase()) {
    case 'review':
    case 'recenzie':
      return 'Scanează pentru recenzie';
    case 'facebook':
      return 'Scanează pentru Facebook';
    case 'instagram':
      return 'Scanează pentru Instagram';
    case 'website':
      return 'Scanează pentru website';
    case 'social':
    case 'social-media':
      return 'Scanează pentru Social Media';
    default:
      return 'Scanează pentru a continua';
  }
}

function buildQrUrlForText(url) {
  // External QR renderer; image source is https and compatible with CSP img-src.
  return `https://api.qrserver.com/v1/create-qr-code/?size=640x640&margin=10&data=${encodeURIComponent(url)}`;
}

function openExternalActionQrPopup(actionType, url, options = {}) {
  const popup = document.getElementById('externalActionPopup');
  const titleEl = document.getElementById('externalActionPopupTitle');
  const qrEl = document.getElementById('externalActionPopupQr');
  const subtextEl = document.getElementById('externalActionPopupSubtext');
  if (!popup || !titleEl || !qrEl || !subtextEl) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }
  const customTitle = String(options?.title || '').trim();
  const customSubtext = String(options?.subtext || '').trim();
  const customImageUrl = sanitizeImageSrc(options?.imageUrl || '');

  titleEl.textContent = customTitle || getExternalActionTitle(actionType);
  qrEl.src = customImageUrl || buildQrUrlForText(url);
  subtextEl.textContent = customSubtext || 'Scanează cu telefonul pentru a continua.';
  popup.classList.add('active');
}

export function closeExternalActionPopup() {
  const popup = document.getElementById('externalActionPopup');
  const qrEl = document.getElementById('externalActionPopupQr');
  if (popup) popup.classList.remove('active');
  if (qrEl) qrEl.removeAttribute('src');
}

export function openExternalAction(actionType) {
  const currentSettings = getCurrentSettings();
  const actionKey = String(actionType || '').toLowerCase();
  const url = getExternalActionUrl(actionType, currentSettings);
  if (!url) {
    showSnackbar('Link indisponibil');
    return;
  }

  if (isKioskTabletMode()) {
    const smPlatforms = ['facebook', 'instagram', 'tiktok'];
    if (smPlatforms.includes(actionKey) || actionKey === 'social' || actionKey === 'social-media') {
      openExternalActionQrPopup(actionType, url);
      return;
    }
    openExternalActionQrPopup(actionType, url);
    return;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
}

// Feedback popup functions
export function openFeedbackPopup() {
  openExternalAction('review');
}

export function closeFeedbackPopup() {
  const popup = document.getElementById('feedbackPopup');
  if (popup) {
    popup.classList.remove('active');
  }
}

// Make available globally for onclick handlers
window.openLocationMenu = openLocationMenu;
window.openLocationMenuExternal = openLocationMenuExternal;
window.closeLocationMenuMode = closeLocationMenuMode;
window.openClientCampaignFromMenuMode = openClientCampaignFromMenuMode;
window.openExternalAction = openExternalAction;
window.closeExternalActionPopup = closeExternalActionPopup;
window.openFeedbackPopup = openFeedbackPopup;
window.closeFeedbackPopup = closeFeedbackPopup;

// „Voucherele mele” pe pagina publică (vouchere salvate pe acest telefon)
// după ce s-a aplicat tema (la tema Cloud voucherele sunt în Joy, fără buton plutitor)
setTimeout(() => {
  import('../ui/voucher.js?v=82.86').then((m) => m.mountVoucherWalletButton()).catch(() => {});
}, 3500);
